module.exports = __webpack_public_path__ + "static/privacy-policy-6f97108c23d9a0e973bff25ab1fe174f.jpg";